import { render, staticRenderFns } from "./paymentPage.vue?vue&type=template&id=31f142da&scoped=true&"
import script from "./paymentPage.vue?vue&type=script&lang=js&"
export * from "./paymentPage.vue?vue&type=script&lang=js&"
import style0 from "./paymentPage.vue?vue&type=style&index=0&id=31f142da&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f142da",
  null
  
)

export default component.exports